import React, { Component } from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { UiLoginHelper } from '../helpers/UiLoginHelper';
import { Helper } from '../helpers/Helper';

export class NumericOTPInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth >
        <InputLabel htmlFor='OTP'>{Helper.getString('otp')}</InputLabel>
        <Input {...this.props} type='password' />
      </FormControl>
    )
  }
}

export class PasswordInput extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormControl fullWidth >
        <InputLabel htmlFor='password'>{this.props.placeholder ? this.props.placeholder : Helper.getString('enterPassword') }</InputLabel>
        <Input {...this.props} type='password' />
      </FormControl>
    )
  }
}

export class UsernameInput extends Component {
  constructor(props) {
    super(props);
    this.userNameType = this.props.userNameType
  }

  render() {
    return (
      <FormControl fullWidth >
        {this.userNameType === UiLoginHelper.UserNameType.PHONE ?
          <InputLabel htmlFor='mobile-number'>{Helper.getString('enterMobile')}</InputLabel>
          :
          <InputLabel htmlFor='email'>{Helper.getString('enterEmail')}</InputLabel>
        }
        <Input {...this.props} />
      </FormControl>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components/TextInputs.js